export const EVENT_SET_ERROR = 'EVENT_SET_ERROR' as const;
export const EVENT_SET_DATA = 'EVENT_SET_DATA' as const;
export const EVENT_SET_OWNERSHIP_DATA = 'EVENT_SET_OWNERSHIP_DATA' as const;
export const EVENT_SET_OWNERSHIP_ERROR = 'EVENT_SET_OWNERSHIP_ERROR' as const;

export const EVENT_MANAGER_URL = {
    api: '/api/v1/events/',
    countryParam: '?country=',
    playersRoute: '/players/'
};
